const locale = {
	USER_DISABLED: 'Access disabled',

	DETAILS_USERS_TAB_ACTIVITIES_KANBAN: 'Activities Kanban',
	DETAILS_USERS_TAB_OPPORTUNITIES_KANBAN: 'Opportunities Kanban',

	// #region User fields
	DETAILS_USERS_FIELD_NAME: 'Name',
	DETAILS_USERS_FIELD_SURNAME: 'Surname',
	DETAILS_USERS_FIELD_MAIL: 'Login Mail',
	DETAILS_USERS_FIELD_RECRUITMENT_DATE: 'Recruitment date',
	DETAILS_USERS_FIELD_RETIREMENT_DATE: 'Retirement date',
	DETAILS_USERS_FIELD_BIRTHDAY: 'Birthday',
	DETAILS_USERS_FIELD_ROLES: 'User Roles',
	DETAILS_USERS_FIELD_QUALIFICATION: 'User Qualification',
	DETAILS_USERS_FIELD_TAXCODE: 'Tax Code',
	DETAILS_USERS_FIELD_HOURLY_RATE: 'Hourly rate',
	DETAILS_USERS_FIELD_ADDRESS: 'Address',
	DETAILS_USERS_FIELD_ADDRESS_CITY: 'Address City',
	DETAILS_USERS_FIELD_ADDRESS_ZIP: 'Address Zip',
	DETAILS_USERS_FIELD_ADDRESS_DISTRICT: 'Address District',
	DETAILS_USERS_FIELD_ADDRESS_REGION: 'Address Region',
	DETAILS_USERS_FIELD_ADDRESS_COUNTRY: 'Address Country',
	DETAILS_USERS_FIELD_ADDRESS_ZONE: 'Address Zone',
	DETAILS_USERS_FIELD_ERP_ID: 'ERP - ID',
	DETAILS_USERS_FIELD_MES_ID: 'MES - ID',
	DETAILS_USERS_FIELD_PUNCH_CLOCK_BARCODE: 'Punch clock - Code',
	DETAILS_USERS_FIELD_ENABLED: 'Enabled',
	DETAILS_USERS_FIELD_USER_COMPANY: 'Company',
	USER_WORKDAY_TIME_START: 'Workday start hour',
	USER_WORKDAY_TIME_END: 'Workday end hour',
	USER_LUNCH_TIME_START: 'Lunch start hour',
	USER_LUNCH_TIME_END: 'Lunch end hour',

	DETAILS_USERS_SECTION_USE_EXISTING: 'Use existing User',
	DETAILS_USERS_SECTION_ADD_NEW: 'Add new User',
	DETAILS_USERS_FIELD_PASSWORD: 'Password',
	DETAILS_USERS_FIELD_CONFIRM_PASSWORD: 'Confirm Password',
	DETAILS_USERS_FIELD_FORCE_RESET_PASSWORD: 'Must change password',
	DETAILS_USERS_CHANGE_PASSWORD_TEXT: 'To modify password go to edit mode',
	DETAILS_USERS_FIELD_ROLE: 'User Role',
	// #endregion

	// #region Details Address section
	DETAILS_USERS_ADDRESS_RESIDENCE_SECTION: 'Residence address',
	DETAILS_USERS_ADDRESS_RESIDENCE_SUBHEADER: 'View and edit the residence address',

	DETAILS_USERS_ADDRESS_DOMICILE_SECTION: 'Domicile address',
	DETAILS_USERS_ADDRESS_DOMICILE_SUBHEADER: 'View and edit the domicile address',
	// #endregion

	// #region User Availability fields
	DETAILS_USERS_AVAILABILITY_FIELD_NAME: 'User',
	DETAILS_USERS_AVAILABILITY_STATUS: 'Permission Status',
	DETAILS_USERS_AVAILABILITY_FIELD_DATE_FROM: 'From',
	DETAILS_USERS_AVAILABILITY_FIELD_DATE_TO: 'To',
	DETAILS_USERS_AVAILABILITY_FIELD_GROUPS: 'Group',
	// #endregion

	// #region User Avatar
	USERS_AVATAR_SECTION: 'Avatar',
	USERS_AVATAR_SUBHEADER: 'View or update your profile avatar',
	// #endregion

	// #region Details system user creation
	USERS_SYSTEM_USER_CREATION_SECTION: 'Perceptive User Data',
	USERS_SYSTEM_USER_CREATION_SUBHEADER: 'Use an existing Perceptive User or create a new one.',
	// #endregion

	// #region Details user system info
	USERS_APPSETTINGS_SECTION: 'Perceptive Account',
	USERS_APPSETTINGS_SUBHEADER: 'View the Perceptive Account details',
	LOGIN_EMAIL: 'Login Email Address',
	ROLE: 'Role',
	LAST_LOGIN: 'Last login',
	PASSWORD: 'Password',
	LOGIN_EMAIL_EDIT_BUTTON: 'Edit Login Mail',

	DETAILS_USERS_STATUS_TITLE: 'Status',
	DETAILS_USERS_STATUS_ACTIVE: 'ACTIVE',
	DETAILS_USERS_STATUS_DISABLED: 'DISABLED',
	// #endregion

	// #region Change Login Mail Dialog
	DIALOG_LOGIN_MAIL_TITLE: 'Edit Login Mail',
	DIALOG_LOGIN_MAIL_DESCRIPTION1: 'Use the "Mail" field to edit the login mail',
	DIALOG_LOGIN_MAIL_DESCRIPTION2: 'Warning! The login address will be modified for each Perceptive App.',
	DIALOG_LOGIN_EMAIL_FIELD: 'Mail',
	// #endregion

	// #region Details User Permissions section
	USERS_PERMISSIONS_SECTION: 'Application Permissions',
	USERS_PERMISSIONS_SUBHEADER: 'View and edit the application permissions',
	NOT_SUPPORTED: 'Setting not supported by the browser',
	PUSH_NOTIFICATIONS_SETTING: 'Push notifications',
	SPEECH_TO_TEXT_SETTING: 'Speech To Text',
	MAIL_NOTIFICATION_SETTING: 'Mail notifications',
	// #endregion

	// #region Details User Saved Filters section
	USERS_SAVEDFILTERS_SECTION: 'Saved filters',
	USERS_SAVEDFILTERS_SUBHEADER: "View the User's saved filters",
	// #endregion

	// #region Details User buttons
	DETAILS_HEADER_BUTTON_NEW_COURSE: 'Add Course',
	// #endregion

	TAB_ATTENDED_COURSES: 'Attended Courses',

	// #region User Daily Report
	USERS_DAILYREPORT_SECTION: 'Daily mail report',
	USERS_DAILYREPORT_SUBHEADER: 'Activate/deactivate the daily mail report',

	DIALOG_TITLE_DAILY_REPORT_SETTINGS: 'Daily mail report settings',
	DAILY_REPORT_FIELD_TEMPLATE: 'Template name',
	DAILY_REPORT_FIELD_CRON: 'Cron',

	DAILY_REPORT_TEMPLATE: 'Template: {template}',
	DAILY_REPORT_TYPE: 'Type: {type}',
	DAILY_REPORT_CREATEDAT: 'Creation at {date}',
	DAILY_REPORT_NEXTEXECUTION: 'Next execution at {date}',
	DAILY_REPORT_RECURRENCE: 'Recurrence: "{cron}"',

	DAILY_REPORT_UNIT_WEEK: 'weeks',
	DAILY_REPORT_UNIT_DAY: 'days',
	DAILY_REPORT_UNIT_HOUR: 'hours',
	DAILY_REPORT_UNIT_MINUTE: 'minutes',
	// #endregion

	USER_LOGIN_LOGS: 'Login logs'
};

export default locale;
